import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Menu, MenuItem } from "@material-ui/core";
import ImportAccountsModal, { ActionType } from "./ImportAccountsModal";

export default function BulkAddButton() {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation("accounts");
  const [actionType, setActionType] = useState<ActionType | null>(null);

  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = event => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const openModal = (type: ActionType) => {
    handleClose();
    setActionType(type);
    setOpen(true);
  };

  const closeModal = () => setOpen(false);

  return (
    <>
      <Button
        color="primary"
        data-testid="accounts__add-bulk-btn"
        aria-controls="bulk-actions"
        aria-haspopup="true"
        disableElevation
        onClick={handleClick}
        style={{ marginLeft: "12px" }}
        variant="contained"
      >
        {t("bulk.action")}
      </Button>
      <Menu
        id="bulk-actions"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem onClick={() => openModal("UPSERT")}>
          <>{t("bulk.upsertAction")}</>
        </MenuItem>
        <MenuItem onClick={() => openModal("UPDATE")}>
          <>{t("bulk.updateAction")}</>
        </MenuItem>
        <MenuItem onClick={() => openModal("DELETE")}>
          <>{t("bulk.deleteAction")}</>
        </MenuItem>
      </Menu>
      {open && (
        <ImportAccountsModal
          isOpen={open}
          onClose={closeModal}
          type={actionType}
        />
      )}
    </>
  );
}
